/* eslint-disable react/prop-types */
import Backdrop from 'components/base/Backdrop';
import React from 'react';

const PageLoader = ({ loading, loadingMessage, fixed = false }) => {
  return (
    <Backdrop
      show={loading}
      className={`flex-column ${fixed ? 'position-fixed ' : ''}`}
    >
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      <p className="mb-1">{loadingMessage}</p>
      <p className="fs-9">please wait...</p>
    </Backdrop>
  );
};

export default PageLoader;
